import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { forgotpassword } from './forgotpassword.reducer';
import { changepassword } from './changepassword.reducer';
import { userlogout } from './logout.reducer';
import { dashboard } from './dashboard.reducer';
import { settings } from './settings.reducer';
import { profile } from './profile.reducer';
import { manageAdmin, exportAdminData } from './manageAdmin.reducer';
import { adminRoles, exportRoleData } from './manageadminroles.reducer';
import { usersList, exportUserData } from './usersList.reducer';
import { groupsList, exportGroupData } from './groups.reducer';
import { resetPassword } from './resetPassword.reducer';
import { userContactsList } from './contacts.reducer';
import { feedback, exportFeedbackData } from './feedback.reducer';
import { help, exportHelpData } from './help.reducer';
import { callManagement, exportCallManagementData } from './callManagement.reducer';
import { exportBroadcastData, broadCast } from './broadCast.reducer';
import { exportTeamData, team } from './team.reducer';
import { appAccessControlUsers,
  appAccessControlAddUser, appAccessControlSwitch,
  appAccessControlDeleteUser, appAccessControlImportUsers,
  aacDownloadSampleCsv, aacExportUsers } from './appAccessControl.reducer';

const rootReducer = combineReducers({
  dashboard,
  authentication,
  forgotpassword,
  changepassword,
  userlogout,
  settings,
  profile,
  manageAdmin,
  adminRoles,
  usersList,
  groupsList,
  resetPassword,
  userContactsList,
  feedback,
  help,
  callManagement,
  exportUserData,
  exportGroupData,
  exportFeedbackData,
  exportRoleData,
  exportAdminData,
  exportHelpData,
  exportCallManagementData,
  exportBroadcastData,
  exportTeamData,
  team,
  appAccessControlUsers,
  appAccessControlAddUser,
  appAccessControlSwitch,
  appAccessControlDeleteUser,
  appAccessControlImportUsers,
  aacDownloadSampleCsv,
  aacExportUsers,
  broadCast
});

export default rootReducer;
